function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable complexity */
import React from 'react';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { switchToBSC } from '@profile/src/utils/ethereum';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { getWalletStatus } from '@profile/src/redux/actions';
import { Dialog } from '@profile/src/Components/DialogModal_V2';
import styles from './styles.module.scss';
import icMetamask from 'assets/img/ic_metamask.png';
import icCoinbase from 'assets/svg/ic_coinbase.svg'; // import icWalletConnect from 'assets/svg/ic_wallet_connect.svg';

import icSequence from 'assets/img/ic_sequence_wallet.png';
import icThetanWallet from 'assets/img/ic_thetan_wallet.png';
import icInfo from 'assets/svg/ic_info_outlined_pink_V2.svg';
import jumbotronBackground from 'assets/img/jumbotron_background_V2.png';
import connectGem from 'assets/img/connect_gem_V2.png';
import { handleWalletError } from './config';
import { openInNewTab, parseLocation } from './utils';
import ConnectWalletProvider, { useConnectWalletContext } from './ConnectWalletProvider';
import { WalletProvider, WalletStatusResponse } from '@profile/src/utils/types';
import withScrollToTop from '@profile/src/utils/withScrollToTop';
import BackButton from '@profile/src/Components/BackButton';
import { useTestId } from '@wolffun/testable-id'; // eslint-disable-next-line max-statements

const ConnectWalletContainer = () => {
  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const {
    startConnectEmail,
    startSignSignature
  } = useConnectWalletContext();
  const history = useHistory();
  const location = useLocation();
  const parsedLocation = parseLocation(location.state);
  const {
    redirectTo = '/buy',
    backTo = '/buy'
  } = parsedLocation;
  const dialogRef = React.useRef(null);
  const [provider, setProvider] = React.useState();
  const walletLoading = useTypedSelector(state => state.connectWallet.loading);
  const walletError = useTypedSelector(state => state.connectWallet.error);
  const userSignInLoading = useTypedSelector(state => state.userSignIn.loading);
  const signedIn = useTypedSelector(state => !!state.userProfile.user);
  const user = useTypedSelector(state => state.userProfile.user);
  const loading = walletLoading || userSignInLoading;

  const goBack = () => {
    history.push(backTo);
  };

  const handleConnectWallet = async (provider = WalletProvider.METAMASK) => {
    if (signedIn) {
      return; // Already connected?
    }

    if (loading) {
      return; // Connection in progress??
    }

    const walletStatus = await dispatch(getWalletStatus(provider));

    if (walletStatus === WalletStatusResponse.ACCOUNT_EXIST) {
      startSignSignature(provider);
    }

    if (walletStatus === WalletStatusResponse.ACCOUNT_NOT_EXIST) {
      startConnectEmail();
    }
  };

  const handleSwitchToBSC = async () => {
    await switchToBSC();
    handleConnectWallet(provider);
  };

  React.useEffect(() => {
    if (!signedIn) {
      return undefined;
    }

    if (user) {
      const timeout = setTimeout(() => {
        history.push(redirectTo);
      }, 300);
      return () => clearTimeout(timeout);
    }

    return undefined;
  }, [signedIn, user]);
  React.useEffect(() => {
    if (!dialogRef.current) {
      return;
    }

    const showDialog = dialogRef.current.showDialog;
    const hideDialog = dialogRef.current.hideDialog;
    handleWalletError(walletError, {
      showDialog,
      hideDialog,
      handleSwitchToBSC
    });
  }, [walletError]);
  const CoinbaseConnectWallet = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.connect, (signedIn || loading) && styles.disabled),
    onClick: () => {
      setProvider(WalletProvider.COINBASE);
      handleConnectWallet(WalletProvider.COINBASE);
    }
  }, generateTestIdProps('coinbase-wallet')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icCoinbase
  }), /*#__PURE__*/React.createElement("span", null, provider === WalletProvider.COINBASE && loading ? 'Connecting...' : 'Login with Coinbase Wallet'), /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, "Recommended"))); // const WalletConnectWallet = (
  //   <div
  //     className={classNames(
  //       styles.connect,
  //       (signedIn || loading) && styles.disabled
  //     )}
  //     onClick={() => {
  //       setProvider(WalletProvider.WALLET_CONNECT);
  //       handleConnectWallet(WalletProvider.WALLET_CONNECT);
  //     }}
  //     {...generateTestIdProps('wallet-connect')}
  //   >
  //     <img className={styles.icon} src={icWalletConnect} />
  //     <span>
  //       {provider === WalletProvider.WALLET_CONNECT && loading
  //         ? 'Connecting...'
  //         : 'Login with Wallet Connect'}
  //     </span>
  //   </div>
  // );

  const SequenceWallet = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.connect, (signedIn || loading) && styles.disabled),
    onClick: () => {
      setProvider(WalletProvider.SEQUENCE);
      handleConnectWallet(WalletProvider.SEQUENCE);
    }
  }, generateTestIdProps('sequence-wallet')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icSequence
  }), /*#__PURE__*/React.createElement("span", null, provider === WalletProvider.SEQUENCE && loading ? 'Connecting...' : 'Login with Sequence Wallet'));
  const ThetanWallet = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.connect, (signedIn || loading) && styles.disabled),
    onClick: () => {
      setProvider(WalletProvider.THETAN_WALLET);
      handleConnectWallet(WalletProvider.THETAN_WALLET);
    }
  }, generateTestIdProps('thetan-wallet')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icThetanWallet
  }), /*#__PURE__*/React.createElement("span", null, provider === WalletProvider.THETAN_WALLET && loading ? 'Connecting...' : 'Login with Thetan Wallet'));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.jumbotron
  }, /*#__PURE__*/React.createElement("img", {
    src: jumbotronBackground,
    className: styles.jumbotronBackground
  }), /*#__PURE__*/React.createElement("img", {
    src: connectGem,
    className: styles.connectGem
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: styles.back,
    onClick: goBack
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.connectWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "CONNECT WALLET")), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", null, "Connect with your available wallet or create new wallet to join our marketplace")), ThetanWallet, SequenceWallet, CoinbaseConnectWallet, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.connect, (signedIn || loading) && styles.disabled),
    onClick: () => {
      setProvider(WalletProvider.METAMASK);
      handleConnectWallet(WalletProvider.METAMASK);
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icMetamask
  }), /*#__PURE__*/React.createElement("span", null, provider === WalletProvider.METAMASK && loading ? 'Connecting...' : 'Login with MetaMask')), /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.note
  }, /*#__PURE__*/React.createElement("span", null, "We do not own your private keys and cannot access your funds without your confirmation.")), /*#__PURE__*/React.createElement("div", {
    onClick: () => openInNewTab('https://doc.thetanarena.com/faqs/terms-of-use'),
    className: styles.toc
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }), /*#__PURE__*/React.createElement("span", null, "See Term Of Use")))), /*#__PURE__*/React.createElement(Dialog, {
    ref: dialogRef
  }));
};

const ConnectWalletPage = () => {
  return /*#__PURE__*/React.createElement(ConnectWalletProvider, null, /*#__PURE__*/React.createElement(ConnectWalletContainer, null));
};

export default withScrollToTop(ConnectWalletPage);